import React from 'react';
import PropTypes from 'prop-types';
import AbstractModalView from '../../../../common/components/AbstractModalView';
import InfoPanel from '../InfoPanel';
import icon from '../../../../common/assets/Clipboard.svg';
import styles from './styles.module.scss';

const StatisticsPopup = ({id, ...rest}) => {
  return (
    <AbstractModalView
      subPath={`info-${id}`}
      modalClassName={styles.modal}
      triggerContent={({openModal}) => (
        <div className={styles.button} onClick={openModal}>
          <img src={icon} alt="stats"/>
        </div>
      )}
      modalContent={({closeModal}) => (
        <div className={styles.modalContainer}>
          <h2 className={styles.modalHeader}> מידע לגבי דו"ח שמספרו - {id}</h2>
          <InfoPanel {...rest} shumaId={id} closeModal={closeModal}/>
        </div>
      )}
    />
  );
};

StatisticsPopup.propTypes = {
  id: PropTypes.number,
};

export default StatisticsPopup;
